module.exports = "/assets/data/51f8d0d6b25d996c6317dcca3ea75a2d-NR19.data.json";